import React, { type JSX } from 'react';

const CATEGORY_STYLES: Record<string, { bg: string; color: string; label: string }> = {
    '0_IDEAL':    { bg: '#E0FCF0', color: '#26835B', label: 'IDEAL' },
    '1_LOW':      { bg: '#E0F7FA', color: '#00838F', label: 'LOW' },
    '2_MEDIUM':   { bg: '#FFFDE7', color: '#F9A825', label: 'MEDIUM' },
    '3_HIGH':     { bg: '#FFE9CC', color: '#F5A73F', label: 'HIGH' },
    '5_CRITICAL': { bg: '#FFCCCC', color: '#E50000', label: 'CRITICAL' },
};

interface Props {
    value: string | null | undefined;
    score : number | null;
}

const chipStyle: React.CSSProperties = {
    display: 'inline-block',
    padding: '2px 8px',
    borderRadius: '16px',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '18px',
    whiteSpace: 'nowrap',
};

const ScoringCategoryBadge = ({ value, score }: Props): JSX.Element | null => {
    if (!value) return <span>—</span>;
    const style = CATEGORY_STYLES[value];
    if (!style) return <span>{value}</span>;
    const showScore = score != null && score > 0.001;
    return (
        <span style={{ ...chipStyle, backgroundColor: style.bg, color: style.color }}>
            {style.label}{showScore ? ` −${score.toFixed(2)}` : ''}
        </span>
    );
};

export default ScoringCategoryBadge;
